import React, { useEffect, useState } from "react";
import "../Components/Cars.css";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase-config";
import CircularProgress from "@mui/material/CircularProgress";

const Cars = () => {
  const [carservices, sethServices] = useState([]);
 const [loading, setLoading] = useState(true);
 
  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true);

        const q = query(
          collection(db, "ownerPageDatas"),
          where("selectedmenutype", "==", "PickupTransportation")
        );

        const querySnapshot = await getDocs(q);

        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        sethServices(data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false); // ✅ important
      }
    };

    fetchServices();
  }, []);


  // 👇 Loader here
  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress size={60} sx={{ color: "#45B2F7" }} />
      </div>
    );
  }

  const carsData = [
    {
      image: "https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?auto=format&fit=crop&w=1200&q=80",
      name: "Company SUV Vehicles",
    },
    {
      image: "https://images.unsplash.com/photo-1609521263047-f8f205293f24?auto=format&fit=crop&w=1200&q=80",
      name: "4x4 Pickup Trucks",
    },
    {
      image: "https://images.unsplash.com/photo-1617814076367-b759c7d7e738?auto=format&fit=crop&w=1200&q=80",
      name: "Passenger Vans",
    },
    {
      image: "https://images.unsplash.com/photo-1563720223185-11003d516935?auto=format&fit=crop&w=1200&q=80",
      name: "Heavy Duty Trucks",
    },
    {
      image: "https://images.unsplash.com/photo-1570125909232-eb263c188f7e?auto=format&fit=crop&w=1200&q=80",
      name: "Luxury Coaches",      // Proper long tourist coach bus
    },
    {
      image: "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&w=1200&q=80",
      name: "Staff & Tourist Buses",
    },
  ];
  const displayData =
    carservices.length > 0 ? carservices : carsData;
  const whatsappNumber = "+966530741843";

  const handleBooking = (carName) => {
    const message = `Hello Jamastar,%0A
I would like to book this vehicle:%0A
🚗 Vehicle Type: ${carName}%0A
Please share availability and price details.`;

    const url = `https://wa.me/${whatsappNumber}?text=${message}`;
    window.open(url, "_blank");
  };

  return (
    <div className="cars-container">
      <div style={{ textAlign: "center" }}>
        <h2 className="cars-title">Pick Our Transportation</h2>
      </div>

      <div className="cars-grid">
        {displayData?.map((car, index) => (
          <div
            key={index}
            className="car-card"
            style={{
              backgroundImage: `url(${car.image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="car-overlay">
              <h3>{car?.description}</h3>

              <button
                className="book-btn"
                onClick={() => handleBooking(car.description)}
              >
                Book Now
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Cars;